import {combineReducers} from "redux";
import govLetterViewModel from "./govLetterViewModel";

const rootViewModel = combineReducers({
    govLetterViewModel,
});

export default rootViewModel;
